import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export var WebimManager = /*#__PURE__*/function () {
  function WebimManager(_accountName, _handlers, _host, _location) {
    var _this = this;
    _classCallCheck(this, WebimManager);
    _defineProperty(this, "accountName", void 0);
    _defineProperty(this, "handlers", void 0);
    _defineProperty(this, "webim", null);
    _defineProperty(this, "location", void 0);
    _defineProperty(this, "host", void 0);
    _defineProperty(this, "init", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var accountName, handlers, location, host;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            accountName = _this.accountName;
            handlers = _this.handlers;
            location = _this.location;
            host = _this.host;
            /* istanbul ignore else */
            if (!window.webim) {
              window.webim = {
                accountName: accountName,
                domain: "".concat(accountName, ".").concat(host),
                location: location
              };
            }

            // eslint-disable-next-line
            _context2.next = 7;
            return new Promise(/*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve) {
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      window.webimHandlers = _objectSpread(_objectSpread({}, handlers), {}, {
                        onInit: resolve
                      });
                      _context.next = 3;
                      return require('./vendor.js');
                    case 3:
                      _this.webim = window.webim;
                      _this.webim.api.init();
                    case 5:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }));
              return function (_x) {
                return _ref2.apply(this, arguments);
              };
            }());
          case 7:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })));
    this.accountName = _accountName;
    this.handlers = _handlers;
    this.location = _location;
    this.host = _host;
  }
  return _createClass(WebimManager, [{
    key: "setUser",
    value: function setUser(userData) {
      window.webim_visitor = userData;
    }
  }, {
    key: "start",
    value: function start() {
      /* istanbul ignore else */
      if (this.webim) {
        this.webim.api.chat.start();
      }
    }
  }, {
    key: "close",
    value: function close() {
      /* istanbul ignore else */
      if (this.webim) {
        this.webim.api.chat.close();
      }
    }
  }]);
}();